import { MarketingPageShell } from "@/components/landing/MarketingPageShell"
import { LegalProse } from "@/components/landing/LegalProse"

export function TermsPage() {
  return (
    <MarketingPageShell
      narrow
      eyebrow="Legal"
      title="Terms & Conditions"
      description="Last updated: August 16, 2025."
      extra="Welcome to Sqaleshop. By accessing or using our platform, you agree to these Terms and Conditions. Please read them carefully."
    >
      <LegalProse>
        <section>
          <h2>1. Acceptance of terms</h2>
          <p>
            By creating an account or using Sqaleshop, you confirm that you understand
            and agree to be bound by these Terms. If you do not agree, you may not use
            the platform.
          </p>
        </section>
        <section>
          <h2>2. Eligibility</h2>
          <p>
            You must be at least 16 years old and capable of entering into a legal
            contract to use Sqaleshop. If you are using the platform on behalf of a
            business, you confirm you have the authority to do so.
          </p>
        </section>
        <section>
          <h2>3. Your account</h2>
          <p>You are responsible for:</p>
          <ul>
            <li>Maintaining account security</li>
            <li>Keeping your login details confidential</li>
            <li>All activity that occurs under your account</li>
          </ul>
          <p>
            Sqaleshop is not liable for loss or damage caused by unauthorized account
            access.
          </p>
        </section>
        <section>
          <h2>4. Use of the platform</h2>
          <p>You agree not to:</p>
          <ul>
            <li>Use Sqaleshop for illegal or fraudulent activities</li>
            <li>Sell prohibited items</li>
            <li>Upload harmful or malicious content</li>
            <li>Attempt to disrupt system operations</li>
          </ul>
          <p>Violations may result in account suspension or termination.</p>
        </section>
        <section>
          <h2>5. Store content &amp; products</h2>
          <p>
            You are fully responsible for all content, descriptions, pricing, and
            products listed on your store. Sqaleshop does not validate or guarantee the
            accuracy of any user generated content.
          </p>
        </section>
        <section>
          <h2>6. Payments &amp; transactions</h2>
          <p>Sqaleshop provides tools for your customers to order products.</p>
          <p>You are responsible for:</p>
          <ul>
            <li>Fulfilling orders</li>
            <li>Handling customer issues</li>
            <li>Receiving payments directly from your customers</li>
            <li>Setting your own pricing and policies</li>
          </ul>
          <p>Sqaleshop does not act as a seller or payment intermediary.</p>
        </section>
        <section>
          <h2>7. Platform availability</h2>
          <p>
            We aim for 99 percent uptime but do not guarantee uninterrupted service.
            Maintenance, upgrades, and unexpected issues may affect availability.
          </p>
        </section>
        <section>
          <h2>8. Intellectual property</h2>
          <p>
            All Sqaleshop code, design, trademarks, and features remain our intellectual
            property. You may use them only as permitted under these Terms.
          </p>
          <p>Your store content remains your property.</p>
        </section>
        <section>
          <h2>9. Termination</h2>
          <p>
            Sqaleshop may suspend or terminate accounts that violate these Terms or harm
            the platform or its users. You may delete your account at any time.
          </p>
        </section>
        <section>
          <h2>10. Limitation of liability</h2>
          <p>Sqaleshop is provided as is. We are not responsible for:</p>
          <ul>
            <li>Lost profits</li>
            <li>Business interruptions</li>
            <li>Data loss</li>
            <li>Customer disputes</li>
            <li>Errors from your advertisements or product listings</li>
          </ul>
          <p>Our liability is limited to the maximum extent permitted by law.</p>
        </section>
        <section>
          <h2>11. Changes to terms</h2>
          <p>
            We may update these Terms occasionally. Continued use of Sqaleshop means you
            accept the revised Terms.
          </p>
        </section>
        <section>
          <h2>12. Contact</h2>
          <p>
            For questions or support:{" "}
            <a className="text-[#451892] hover:underline" href="mailto:support@sqaleshop.com">
              support@sqaleshop.com
            </a>
          </p>
        </section>
      </LegalProse>
    </MarketingPageShell>
  )
}
